/**
 * Button Component
 * Reusable button with variants, icons, and loading states
 *
 * @param {Object} props
 * @param {'primary'|'secondary'|'ghost'} props.variant - Button style variant
 * @param {Function} props.onClick - Click handler
 * @param {string} props.icon - Font Awesome icon class (optional)
 * @param {ReactNode} props.children - Button content
 * @param {boolean} props.disabled - Disabled state
 * @param {boolean} props.loading - Loading state (shows spinner)
 * @param {'button'|'submit'|'reset'} props.type - Button type
 * @param {string} props.className - Additional CSS classes
 */
const Button = ({
  variant = 'primary',
  onClick,
  icon,
  children,
  disabled = false,
  loading = false,
  type = 'button',
  className = ''
}) => {
  // Build CSS classes
  const classes = [
    'psyber-btn',
    `psyber-btn-${variant}`,
    className
  ].filter(Boolean).join(' ')

  // Handle click
  const handleClick = (e) => {
    if (!disabled && !loading && onClick) {
      onClick(e)
    }
  }

  return (
    <button
      type={type}
      className={classes}
      onClick={handleClick}
      disabled={disabled || loading}
    >
      {/* Loading Spinner */}
      {loading && (
        <i className="fas fa-spinner fa-spin"></i>
      )}

      {/* Icon (only show if not loading) */}
      {!loading && icon && (
        <i className={icon}></i>
      )}

      {/* Button Content */}
      {children}
    </button>
  )
}

export default Button
